import { InitialIntegrationReducer } from "../../../../_services/store/InitialIntegrationReducer";
import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_NEW_CONFIGURATION, integrationReducerActions } from "../../../../_commons/integration.reducer";

export const initialKauflandPaymentsReducer = {
    ...new InitialIntegrationReducer(),
    newConfiguration: {
        ...INITIAL_NEW_CONFIGURATION,
    },
};

const kauflandPaymentsSlice = createSlice({
    name: "Kaufland Payments",
    initialState: { ...initialKauflandPaymentsReducer },
    reducers: {
        ...integrationReducerActions,
    },
});

export default kauflandPaymentsSlice;
